import script from "./SpaceBar.vue?vue&type=script&setup=true&lang=js"
export * from "./SpaceBar.vue?vue&type=script&setup=true&lang=js"

import "./SpaceBar.vue?vue&type=style&index=0&id=b04efb20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b04efb20"]])

export default __exports__